import * as systemService from "./system.service";

const INITIAL_STATE = {
  // 发布系统
  release: {},
};

const system = {
  state: {
    ...INITIAL_STATE,
  },
  actions: {
    initSystemRelease({ dispatch }, release) {
      dispatch({ type: "system/initSystemRelease", payload: release });
    },
    getAllSystemRelease({ dispatch }) {
      return systemService.getAllSystemRelease();
    },
  },
  reducers: {
    initSystemRelease(prevState, payload) {
      return {
        ...prevState,
        release: { ...payload, }
      };
    },
  }
}

export default system;
